export default __webpack_public_path__ + "static/business_cycle-da36d758fad8c2071a45572883bcff98.png";